import {Cloneable} from "@/common/Cloneable";
import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";

import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";
import {Schema} from "@/common/Schema";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export class RewardTrack extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(RewardTrack, v) : SKIP;
        }, (v) => {
            return deserialize(RewardTrack, v);
        });
    }

    constructor() {
        super();

        this._product = null;
        this._currency = null;
        this._reward = null;
        this._reminder = [];
        this._resetOnComplete = false;
    }

    get product() {
        return this._product;
    }

    set product(value) {
        this._product = value;
    }

    get currency() {
        return this._currency;
    }

    set currency(value) {
        this._currency = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get reminder() {
        return this._reminder;
    }

    set reminder(value) {

        if (value) {
            value.sort();
        }

        this._reminder = value;
    }

    get resetOnComplete() {
        return this._resetOnComplete;
    }

    set resetOnComplete(value) {
        this._resetOnComplete = value;
    }

    valid() {

        if (!CurrencyKindModel.is(this.currency)) {
            return false;
        }

        if (this.product && !RedactorUtils.getProduct(this.product)) {
            return false;
        }

        if (!this.reward || this.reward.empty() || !this.reward.valid()) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.reward || this.reward.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new RewardTrack());
        } else if (target instanceof RewardTrack) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(RewardTrack, {
    _product: alias("product", Schema.primitive()),
    _currency: alias("currency", CurrencyKindModel.schema()),
    _reward: alias("reward", RewardBunch.schema()),
    _reminder: alias("reminder", list(Schema.primitive())),
    _resetOnComplete: alias("reset_complete", Schema.primitive())
})